// extracted by mini-css-extract-plugin
export default {"moreButton":"A2weo2","icon":"DUY8Cx"};